import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import PriceService from "src/services/price-service"
import { columnsPrecoVariacaoDiaria } from "./tabela-preco-variacao-constants"
import DataGridScrollTable from "../../../../components/Table/data-grid-scroll-table"

const TabelaPrecoVariacao = ({ date, setLoading, setExportFileCsv, loading }) => {
    const priceService = new PriceService()
    const [priceList, setPriceList] = useState([])

    useEffect(() => {
        setExportFileCsv(() => () => priceService.exportDataVariationToCsv(date))
        loadPrices()
    }, [date])

    const loadPrices = () => {
        setLoading(true)
        priceService.loadTablePriceVariantion(date, date)
            .then((response) => {
                const { body } = response
                const { data } = body
                const rows = data.map((obj, index) => ({ ...obj, id: index }))
                setPriceList(rows)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <DataGridScrollTable
            rows={priceList}
            columns={columnsPrecoVariacaoDiaria()}
            loading={loading}
            pointerCursor
            height={600}
            disableRowSelectionOnClick
            sortingOrder={['asc', 'desc']}
        />
    )
}

TabelaPrecoVariacao.propTypes = {
    date: PropTypes.string,
    setLoading: PropTypes.func,
    loading: PropTypes.bool,
    setExportFileCsv: PropTypes.func,
}

export default TabelaPrecoVariacao